/**
 * 데모 기준 시각. 🔴 `new Date()` 를 쓰지 않는다 —
 * fixture 가 실행할 때마다 달라지면 스냅샷 테스트도 화면 확인도 재현이 안 된다.
 *
 * 와이어프레임의 데모 시각(`14:20:03` · `B-260911-02`)에 맞췄다. 표시 시간대는 KST.
 */
export const DEMO_NOW = '2026-09-11T14:20:03+09:00'

/** 기준 시각에서 `seconds` 만큼 떨어진 ISO 문자열 */
export function demoTime(seconds: number): string {
  return new Date(Date.parse(DEMO_NOW) + seconds * 1000).toISOString()
}

/** 기준 시각에서 `days` 일 전 ISO 문자열 */
export function demoDaysAgo(days: number): string {
  return demoTime(-days * 24 * 3600)
}
